import { render } from "./activateAccount.vue?vue&type=template&id=156e8922&scoped=true"
import script from "./activateAccount.vue?vue&type=script&lang=js"
export * from "./activateAccount.vue?vue&type=script&lang=js"

import "./activateAccount.vue?vue&type=style&index=0&id=156e8922&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156e8922"]])

export default __exports__